import { $generateHtmlFromNodes } from '@lexical/html'
import {
  LineBreakNode,
  ParagraphNode,
  TextNode,
  createEditor,
  type CreateEditorArgs,
  type SerializedEditorState,
} from 'lexical'
import { useMemo } from 'react'

type SerializedLexicalState = string | SerializedEditorState

interface LexicalHtmlRendererProps {
  description: unknown
  initialConfig?: CreateEditorArgs
}

class ParagraphElementNode extends ParagraphNode {
  static getType(): string {
    return 'paragraph-element'
  }

  static clone(node: ParagraphElementNode): ParagraphElementNode {
    return new ParagraphElementNode(node.__key)
  }
}

export const lexicalRendererConfig: CreateEditorArgs = {
  namespace: 'portfolio-description-renderer',
  theme: {},
  onError(error) {
    // Re-throw so errors surface during development
    throw error
  },
  nodes: [ParagraphElementNode, ParagraphNode, TextNode, LineBreakNode],
}

export function LexicalHtmlRenderer({
  description,
  initialConfig = lexicalRendererConfig,
}: LexicalHtmlRendererProps) {
  const editor = useMemo(() => createEditor(initialConfig), [initialConfig])
  const html = useMemo(() => {
    if (!description) return ''

    const state = editor.parseEditorState(description as SerializedLexicalState)

    let htmlString = ''
    state.read(() => {
      htmlString = $generateHtmlFromNodes(editor)
    })

    return htmlString
  }, [description, editor])

  if (!html) return null

  // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
  return <div dangerouslySetInnerHTML={{ __html: html }} />
}
